import {EntityType} from './EntityType';
import {ImageType} from './ImageType';

/**
 * Handles the mapping of the different type enums in the FuPa ecosystem.
 */
export class TypeMappings {
  private static readonly VALID_ENTITY_TYPES = Object.values(EntityType) as string[];

  /**
   * Attempts to map an image type to an entity type. Note, that this is not supported
   * for all of the image types.
   */
  public static imageTypeToEntityType(imageType: ImageType): EntityType | undefined {
    if (imageType === ImageType.Player) {
      return EntityType.Profile;
    }
    if (TypeMappings.VALID_ENTITY_TYPES.includes(imageType as string)) {
      return (imageType as unknown) as EntityType;
    }
    return undefined;
  }
}
